<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="video" v-show="video">
            <div class="center">
                <div class="icon icon_close" title="关闭" @click="show_home_video('0')"></div>
                <video class="video-js" preload="auto" :src="mp4Url" style="width:100%;height:100%;" controls :poster="cover" :muted="muteStatus" :autoplay="playStatus" ></video>
            </div>
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">关于凯纳</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiJianJie')">公司简介</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeWenHua')">企业文化</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheHuiZeRen')">社会责任</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ZiZhiRongYu')">企业荣誉</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiZiZhi')">公司资质</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('DangJianGongHui')">党建工会</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YuanGongFengCai')">员工风采</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeHuaCe')">企业画册</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeXuanChuanPian')">企业宣传片</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>

                    <div id="contnet">

                        <h3>企业宣传片</h3>
                       
                        <ul class="video_list">
                            <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner_new_2024.mp4')"><img src="../assets/img/video_0.jpg" /><span>哈尔滨凯纳科技股份有限公简介&nbsp;(5'23")</span></div></li>
                        </ul>

                        <h3>产品宣传片</h3>
                        <ul class="video_list">
                            <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner.mp4')"><img src="../assets/img/video_4.jpg" /><span>凯纳智慧供水软件产品介绍&nbsp;(1'40")</span></div></li>
                            <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner_sbtjs.mp4')"><img src="../assets/img/video_5.jpg" /><span>凯纳智慧泵站/数字双胞胎介绍&nbsp;(0'26")</span></div></li>
                            <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner_bzzhgl_1.mp4')"><img src="../assets/img/video_6.jpg" /><span>凯纳泵站智慧管理系统&nbsp;(2'07")</span></div></li>
                            <!-- <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner_ncwscl.mp4')"><img src="../assets/img/video_7.jpg" /><span>凯纳农村污水处理系统&nbsp;(3'26")</span></div></li> -->
                            <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner_fhswszl.m4v')"><img src="../assets/img/video_8.jpg" /><span>分户式污水治理宣传片&nbsp;(3'25")</span></div></li>
                        </ul>
                        
                    </div>


                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Home',
    data() {
        return {
            title: '企业宣传片',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            webTitle:'',
            webDescription:'',

            video: false,
            cover: '',// 封面
            muteStatus: false, // 是否静音自动播放
            playStatus: false, //是否自动播放
            mp4Url:'',

        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        show_home_video( e,url ){
            if( e == 1 ){
                this.video = true;
                this.playStatus = true;
                this.muteStatus = false;
                this.mp4Url = url;
            }else{
                this.video = false;
                this.playStatus = false;
                this.muteStatus = false;
                this.mp4Url = '';
            };
            
        },
    },
};
</script>
<style lang="less" scoped>

.video_list{
    display: block;
    zoom:1;
    overflow: auto;
    margin: 10px 0px;

    li{
        float: left;
        width: 33.333333%;
        text-align: center;
        padding: 10px 0px;

        div{
            margin: 0px auto;
            padding: 10px 0px;
            width: 300px;
            height: 209px;
            background-color: #f2f2f2;
            border-radius: 10px;
            overflow: hidden;

            span{
                display: block;
                height: 35px;
                line-height: 35px;
                color:#171615;
                font-size: 13px;
            }

            img{
                width: 300px;
                height: 169px;
                vertical-align: top;
                filter: blur(0px);
                border-radius: 5px;
            }
        }
    }
    li:hover{
        cursor: pointer;
        
        div{
            box-shadow: 0px 0px 10px rgba( 0,0,0,0.5 );
            background-color: #fff;
            img{
                animation: li_img_hover 0.5s linear forwards;
                
                @keyframes li_img_hover {
                    0% {
                        filter: blur(0px);
                    }
                    50% {
                        filter: blur(2px);
                    }
                    100% {
                        filter: blur(0px);
                    }
                }

            }
        }
    }
}

.video{
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 99;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.8);
    text-align: center;

    .center{
        position: relative;
        margin: 8% auto 10% auto;
        width: 960px;
        height: 540px;
        background-color: #000;
        border-radius: 10px;

        .icon{
            cursor: pointer;
            position: absolute;
            z-index: 99;
            top: -30px;
            right: -70px;
            width: 50px;
            height: 50px;
            border-radius: 100px;
            background-position: center center;
            background-size: 30px 30px;
            background-color: rgba(0, 0, 0, 0.5);
        }
        .icon:hover{
            background-color: rgba(0, 0, 0, 0.9);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/QiYeXuanChuanPian.vue